import React from "react";
import { toast } from "react-toastify";

const truncateId = (value, length = 10) => {
  const text = value === null || value === undefined ? "" : String(value).trim();
  if (!text || text.toUpperCase() === "N/A") {
    return { display: "N/A", full: "", canCopy: false };
  }
  if (text.length <= length) {
    return { display: text, full: text, canCopy: true };
  }
  return {
    display: `${text.slice(0, length)}....`,
    full: text,
    canCopy: true,
  };
};

function CopyableId({ value, className = "", length = 10 }) {
  const { display, full, canCopy } = truncateId(value, length);

  const handleCopy = async (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (!canCopy || !full) return;

    try {
      await navigator.clipboard.writeText(full);
      toast.success("ID copied");
    } catch (error) {
      toast.error("Failed to copy ID");
    }
  };

  if (!canCopy) {
    return <span className={className}>{display}</span>;
  }

  return (
    <span
      className={className}
      style={{ cursor: "pointer", userSelect: "none" }}
      title={full}
      role="button"
      tabIndex={0}
      onClick={handleCopy}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          handleCopy(event);
        }
      }}
    >
      {display}
    </span>
  );
}

export default CopyableId;
